export default [
  // 课程管理
  {
    path: '/courseback/:courseID',
    component: () => import('@/views/pages/courseBack/index'),
    redirect: '/courseback/:courseID/statistic',
    children: [
      {
        path: 'chapter',
        component: () => import('@/views/pages/courseBack/chapter/index'),
        redirect: '/courseback/:courseID/chapter',
        children: [
          {
            path: 'create',
            name: 'create',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          },
          {
            path: '',
            name: 'chapter',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/chapter/empty')
          },
          {
            path: ':chapterID/section/create',
            name: 'create',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chapter',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "课程管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          }
        ]
      },
      {
        path: 'video',
        component: () => import('@/views/pages/courseBack/chapter/index'),
        redirect: '/courseback/:courseID/chapter',
        children: [
          {
            path: 'create',
            name: 'create',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          },
          {
            path: '',
            name: 'chapter',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/chapter/empty')
          },
          {
            path: ':chapterID/section/create',
            name: 'create',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chapter',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          }
        ]
      },
      {
        path: 'all',
        component: () => import('@/views/pages/courseBack/chapter/index'),
        redirect: '/courseback/:courseID/all',
        children: [
          {
            path: 'create',
            name: 'create',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          },
          {
            path: '',
            name: 'chapter',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/chapter/empty')
          },
          {
            path: ':chapterID/section/create',
            name: 'create',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chapter',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "视频管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          }
        ]
      },
      {
        path: 'docs',
        component: () => import('@/views/pages/courseBack/chapter/index'),
        redirect: '/courseback/:courseID/chapter',
        children: [
          {
            path: 'create',
            name: 'create',
            meta: { title: "备课资料" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          },
          {
            path: '',
            name: 'chapter',
            meta: { title: "备课资料" },
            component: () => import('@/views/pages/courseBack/chapter/empty')
          },
          {
            path: ':chapterID/section/create',
            name: 'create',
            meta: { title: "备课资料" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chapter',
            meta: { title: "备课资料" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "备课资料" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          }
        ]
      },
      {
        path: 'homework',
        component: () => import('@/views/pages/courseBack/chapter/index'),
        redirect: '/courseback/:courseID/homework',
        children: [
          {
            path: 'create',
            name: 'create',
            meta: { title: "作业管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          },
          {
            path: '',
            name: 'homework',
            meta: { title: "作业管理" },
            component: () => import('@/views/pages/courseBack/chapter/empty')
          },
          {
            path: ':chapterID/section/create',
            name: 'create',
            meta: { title: "作业管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID/section/:sectionID',
            name: 'chapter',
            meta: { title: "作业管理" },
            component: () => import('@/views/pages/courseBack/section/index')
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "作业管理" },
            component: () => import('@/views/pages/courseBack/chapter/chapter')
          }
        ]
      },
      {
        path: 'member',
        name: 'member',
        meta: { title: "成员管理" },
        component: () => import('@/views/pages/courseBack/member/index.vue')
      },
      {
        path: 'log',
        name: 'log',
        meta: { title: "操作记录" },
        component: () => import('@/views/pages/courseBack/log/index.vue')
      },
      {
        path: 'pointlog',
        name: 'pointlog',
        meta: { title: "操作记录" },
        component: () => import('@/views/pages/courseBack/log/point.vue')
      },
      {
        path: 'notifications',
        name: 'notifications',
        meta: { title: "公告发布" },
        component: () => import('@/views/pages/courseBack/notifications/index.vue')
      },
      {
        path: 'exam',
        name: 'exam',
        meta: { title: "考试管理" },
        component: () => import('@/views/pages/courseBack/exam/index.vue')
      },
      {
        path: 'setting',
        name: 'setting',
        meta: { title: "课程设置" },
        component: () => import('@/views/pages/courseBack/setting/index.vue')
      },
      {
        path: 'statistic',
        meta: { title: "数据统计" },
        component: () => import('@/views/pages/courseBack/statistic/index.vue'),
        redirect: '/courseback/:courseID/statistic',
        children: [
          {
            path: '',
            name: 'statistic',
            meta: { title: "数据统计" },
            component: () => import('@/views/pages/courseBack/chapter/empty.vue'),
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "数据统计" },
            component: () => import('@/views/pages/courseBack/statistic/chapter.vue'),
          },
          {
            path: ':chapterID/:sectionID',
            name: 'section',
            meta: { title: "数据统计" },
            component: () => import('@/views/pages/courseBack/statistic/section.vue'),
          },
          {
            path: ':chapterID/:sectionID/:userID',
            name: 'user',
            meta: { title: "数据统计" },
            component: () => import('@/views/pages/courseBack/statistic/user.vue'),
          }
        ]
      },
      {
        path: 'hwstats',
        meta: { title: "作业统计" },
        component: () => import('@/views/pages/courseBack/statistic/index.vue'),
        redirect: '/courseback/:courseID/hwstats',
        children: [
          {
            path: '',
            name: 'hwstats',
            meta: { title: "作业统计" },
            component: () => import('@/views/pages/courseBack/chapter/empty.vue'),
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "作业统计" },
            component: () => import('@/views/pages/courseBack/statistic/chapter.vue'),
          },
          {
            path: ':chapterID/:sectionID',
            name: 'section',
            meta: { title: "作业统计" },
            component: () => import('@/views/pages/courseBack/statistic/section.vue'),
          },
          {
            path: ':chapterID/:sectionID/:userID',
            name: 'user',
            meta: { title: "作业统计" },
            component: () => import('@/views/pages/courseBack/statistic/user.vue'),
          }
        ]
      },
      {
        path: 'students',
        meta: { title: "学生管理" },
        component: () => import('@/views/pages/courseBack/students/index.vue'),
        redirect: '/courseback/:courseID/students',
        children: [
          {
            path: '',
            name: 'empty',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/courseBack/students/empty.vue'),
          },
          {
            path: ':userID',
            name: 'student',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/courseBack/students/student.vue'),
          },
          {
            path: ':userID/:chapterID',
            name: 'student',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/courseBack/students/student.vue'),
          }
        ]
      },
      {
        path: 'point',
        meta: { title: "积分管理" },
        component: () => import('@/views/pages/courseBack/point/index.vue'),
        redirect: '/courseback/:courseID/point',
        children: [
          {
            path: '',
            name: 'empty',
            meta: { title: "积分管理" },
            component: () => import('@/views/pages/courseBack/point/empty.vue'),
          },
          {
            path: ':userID',
            name: 'student',
            meta: { title: "积分管理" },
            component: () => import('@/views/pages/courseBack/point/student.vue'),
          }
        ]
      },
      {
        path: 'report',
        meta: { title: "学生管理" },
        component: () => import('@/views/pages/courseBack/report/index.vue'),
        redirect: '/courseback/:courseID/report',
        children: [
          {
            path: '',
            name: 'empty',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/courseBack/report/empty.vue'),
          },
          {
            path: ':userID',
            name: 'student',
            meta: { title: "学生管理" },
            component: () => import('@/views/pages/courseBack/report/student.vue'),
          }
        ]
      },
      {
        path: 'cdshow',
        meta: { title: "备课视频" },
        component: () => import('@/views/pages/courseBack/statistic/index.vue'),
        redirect: '/courseback/:courseID/hwstats',
        children: [
          {
            path: '',
            name: 'hwstats',
            meta: { title: "备课视频" },
            component: () => import('@/views/pages/courseBack/chapter/empty.vue'),
          },
          {
            path: ':chapterID',
            name: 'chapter',
            meta: { title: "备课视频" },
            component: () => import('@/views/pages/courseBack/chapter/empty.vue'),
            // component: () => import('@/views/pages/courseBack/statistic/chapter.vue'),
          },
          {
            path: ':chapterID/:sectionID',
            name: 'section',
            meta: { title: "备课视频" },
            component: () => import('@/views/pages/courseBack/statistic/video.vue'),
          }
        ]
      }
    ]
  }
]